import { Text } from "@hopper-ui/components";
import { ConnectorChannelIcon } from "#components/ui/ConnectorChannelIcon.tsx";
import { Channel } from "#features/channels/components/channels-details/Channel.tsx";
import { ConnectChannel } from "#features/channels/components/channels-details/ConnectChannel.tsx";
import type { GetChannelsDetailsQueryCustomMcpServer } from "#types/types.ts";

interface Props {
    customMcpServer: GetChannelsDetailsQueryCustomMcpServer;
}

export const CustomMcpServerItem = ({ customMcpServer }: Props) => {
    const { displayName, description, isConnected, isExpired } = customMcpServer;

    if (!isConnected || isExpired) {
        return (
            <ConnectChannel
                icon={<ConnectorChannelIcon type="None" />}
                title={displayName}
                description={description ?? undefined}
            />
        );
    }

    return (
        <Channel
            icon={<ConnectorChannelIcon type="None" />}
            title={displayName}
        >
            {description
                ? (
                    <Text size="xs" color="neutral-weak">
                        {description}
                    </Text>
                )
                : null}
        </Channel>
    );
};
